import * as React           from 'react'
import { FormattedMessage } from 'react-intl'

import Grid from '@material-ui/core/Grid'

import { LabelledText } from '../atoms'

const LabelledData = ({ data, direction = 'column' }) => {
  return (
    <Grid container direction={direction as any} spacing={8}>
      {Object.keys(data).map(key => {
        const value = data[ key ]

        const label = <FormattedMessage id={`labels.${key}`} />

        if (typeof value === 'string' && !value.trim().length) return null

        return (
          <Grid item key={key}>
            <LabelledText label={label}>
              {value}
            </LabelledText>
          </Grid>
        )
      })}
    </Grid>
  )
}

export default LabelledData



// WEBPACK FOOTER //
// ./src/components/molecules/LabelledData.tsx